import { replaceVideoSrcs, videoIsPlaying } from './video.service';
document.addEventListener('DOMContentLoaded', () => {
    const videoEl = document.getElementById('hero-video-el');
    const options = {
        rootMargin: '0px',
        threshold: [0, 1],
    };
    let initialLoad = true;
    const observer = new IntersectionObserver(event => {
        if (event[0].isIntersecting) {
            if (initialLoad) {
                replaceVideoSrcs(videoEl);
                initialLoad = false;
            }
            if (!videoIsPlaying(videoEl)) {
                videoEl.play();
            }
        }
        else if (!event[0].isIntersecting && videoIsPlaying(videoEl)) {
            videoEl.pause();
        }
    }, options);
    observer.observe(videoEl);
});
